<template>
  <Cluster>
    <IconButton
      class="timer-control"
      variant="outline"
      :icon="timerPaused ? 'play' : 'pause'"
      @click="pauseTimer"
      :data-show="timerStarted"
    >
      {{ timerPaused ? "Timer fortfahren" : "Timer pausieren" }}Timer pausieren
    </IconButton>
    <span class="text-4">{{ formattedTimeLeft }}</span>
    <IconButton
      class="timer-control"
      variant="outline"
      icon="cancel"
      @click="stopTimer"
      :data-show="timerStarted"
    >
      Timer abbrechen
    </IconButton>
  </Cluster>
</template>

<script>
import { computed, ref, watch } from "vue";
import IconButton from "../block/IconButton.vue";
import Cluster from "../composition/Cluster.vue";

export default {
  components: {
    IconButton,
    Cluster,
  },
  props: {
    time: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  setup(props) {
    // timePassed will be substracted from time prop to calc the time left
    const timePassed = ref(0);
    // Ref to hold the interval
    const timerInterval = ref();
    // Boolean status to indicate if the timer is active
    const timerStarted = ref(false);
    // Indicate if the timer is paused
    const timerPaused = ref(false);

    const timerBeep = require("@/assets/sounds/beep.mp3");
    const timerBell = require("@/assets/sounds/bell.mp3");

    const playAudio = async (sound) => {
      let audio = new Audio(sound);
      audio.type = "audio/mp3";
      try {
        await audio.play();
      } catch (error) {
        console.log(error);
      }
    };

    // Calculate timeLeft
    const timeLeft = computed(() => {
      return props.time - timePassed.value;
    });

    const formattedTimeLeft = computed(() => {
      // The largest round integer less than or equal to the result of time divided being by 60.;
      let minutes = Math.floor(timeLeft.value / 60);
      // Seconds are the remainder of the time divided by 60(modulus operator);
      let seconds = timeLeft.value % 60;
      // If the value of seconds is less than 10, then display seconds with a leading zero;;
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      // If the value of seconds is less than 10, then display seconds with a leading zero;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      // The output in MM:SS format
      return `${minutes}:${seconds}`;
    });

    const startTimer = () => {
      timerStarted.value = true;
      // Reset timePassed back to 0
      timePassed.value = 0;
      // Start an interval to increment timePassed every second
      timerInterval.value = setInterval(() => {
        if (!timerPaused.value) {
          timePassed.value += 1;
        }
      }, 1000);
    };

    const stopTimer = () => {
      timerStarted.value = false;
      // Clear the timerInterval
      clearInterval(timerInterval.value);
    };

    const pauseTimer = () => {
      timerPaused.value = !timerPaused.value;
    };

    // Watch timeLift and call stopTimer method if the newValue === 0
    watch(timeLeft, (newValue) => {
      if (newValue < 4 && newValue > 0) {
        playAudio(timerBeep);
      }
      if (newValue === 0) {
        playAudio(timerBell);
        stopTimer();
      }
    });

    return {
      formattedTimeLeft,
      startTimer,
      stopTimer,
      pauseTimer,
      timerStarted,
      timerPaused,
    };
  },
};
</script>

<style lang="scss" scoped>
.timer-control {
  --translate: 200%;
  --opacity: 0;
  transform: translateX(var(--translate));
  opacity: var(--opacity);
  transition: transform 300ms ease-out, opacity 200ms ease-out;

  &[data-show="true"] {
    --opacity: 1;
    --translate: 0;
  }
}

.timer-control:where(:last-child) {
  --translate: -200%;
}
</style>
